module.exports = __webpack_public_path__ + "img/temp_pub_4.1.0d13530d.jpg";